import React, {Fragment} from 'react';
import createForm from "./Form";
import Select from "../../form/Select";
import DateTimeInput from "../../form/DateTimeInput";
import CheckBox from "../../form/CheckBox";
import ComponentField from "../../form/ComponentField";
import SeoField from "../../form/SeoField";

class ExactProductForm extends React.Component {
    render() {
        return (
            <Fragment>
                <div className="row form-row">
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Megnevezés/Név"
                        />
                    </div>
                    <div className="col-sm-2">
                        <Select
                            optionname="ProductState"
                            name="state"
                            value={this.props.values.state}
                            label="Elérhetőség"
                            storeType="local"
                            objectValue={false}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="barcode"
                            type="number"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Vonalkód"
                        />
                    </div>
                    <div className="col-sm-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="sku"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="ISBN"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="listprice"
                            type="number"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Lista ár"
                        />
                    </div>
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="tradename"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kiadó"
                        />
                    </div>
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="category"
                            storeType="local"
                            objectValue={true}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Típus"
                        />
                    </div>
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="vat"
                            storeType="local"
                            objectValue={true}
                            disabled={true}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Áfa érték"
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

class productShortFormComponent extends React.Component {
    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <ExactProductForm {...this.props} />
            </form>
        );
    }
}

export const productShortForm = createForm(productShortFormComponent);

class productForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <ExactProductForm {...this.props} />
                <div className="row form-row">
                    <div className="col-md-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="productclass"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kategória"
                        />
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="productclasses"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kategóriák"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-sm-2">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="weight"
                                    type="number"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Súly"
                                />
                            </div>
                            <div className="col-sm-2">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="width"
                                    type="number"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Szélesség"
                                />
                            </div>
                            <div className="col-sm-2">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="length"
                                    type="number"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Hosszúság"
                                />
                            </div>
                            <div className="col-sm-2">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="height"
                                    type="number"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Magasság"
                                />
                            </div>
                            <div className="col-sm-2">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="pagenum"
                                    type="number"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Lapszám"
                                />
                            </div>
                            <div className="col-sm-2">
                                {/*<DateTimeInput
                                    showTime={true}
                                    name="pub_year"
                                    value={this.props.values.pub_year}
                                    label="Kiadás dátuma"
                                    {...this.props.getFieldProps("pub_year")}
                                    saveChanges={this.props.setFieldValue}
                                />*/}
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="pub_year"
                                    type="number"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Kiadás dátuma"
                                />
                            </div>
                            <div className="col-sm-2">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    fieldEditorType={DateTimeInput}
                                    name="pub_date"
                                    yearRange={"2000:" + ((new Date().getFullYear()) + 1)}
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Kiadás dátuma"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-2">
                        <Select
                            optionname="cover_type"
                            name="cover"
                            value={this.props.values.cover}
                            label="Borító típusa"
                            storeType="local"
                            objectValue={false}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="from_age"
                            type="number"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Életkortól"
                        />
                    </div>
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="to_age"
                            type="number"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Életkorig"
                        />
                    </div>
                    <div className="col-sm-3">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="series"
                            objectValue={true}
                            storeType="remote"
                            isClearable={true}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Sorozat"
                        />
                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="volume"
                                    type="number"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Sorszám"
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="edition_number"
                                    type="number"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Kiadás sorszáma"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="images"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Képek"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <CheckBox
                            name="flipbook_even"
                            {...this.props.getFieldProps("flipbook_even")}
                            saveChanges={this.props.setFieldValue}
                            value={this.props.values.flipbook_even}
                            label="Páros lapozó"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Select
                            name="tags"
                            component={this.props.componentConfig.fielddefs.tags.objects}
                            value={this.props.values.tags}
                            saveChanges={this.props.setFieldValue}
                            isMulti={true}
                            label="Cimkék"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="short_desc"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Rövid leírás"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="description"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Leírás"
                        />
                    </div>
                </div>
                <ComponentField
                    getFieldProps={this.props.getFieldProps}
                    componentConfig={this.props.componentConfig}
                    name="url"
                    values={this.props.values}
                    setFieldValue={this.props.setFieldValue}
                    label="Url"
                />
                {/*<ComponentField
                    getFieldProps={this.props.getFieldProps}
                    componentConfig={this.props.componentConfig}
                    name="seo"
                    values={this.props.values}
                    setFieldValue={this.props.setFieldValue}
                    label="Seo"
                />*/}
                <ComponentField
                    getFieldProps={this.props.getFieldProps}
                    componentConfig={this.props.componentConfig}
                    name="priority"
                    values={this.props.values}
                    setFieldValue={this.props.setFieldValue}
                    label="Prioritás"
                />
                <SeoField {...this.props}/>
            </form>
        );
    }
}

export default createForm(productForm);